<template>
     <el-container class="home-container">

        <el-header style="text-align: right; font-size: 12px;">
            <div>
                <img src="../assets/logo1.png"/>
                <span style="font-size:25px;">构建系统</span>
                <el-menu class="el-menu-demo" mode="horizontal" 
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
                default-active="/home/orderInfo"
                router>
                    <el-submenu index="1" v-if="isDisabled">
                        <template slot="title"><i class="el-icon-setting"></i>基础设置</template>
                        <el-menu-item index="/home/user" >
                            用户管理
                        </el-menu-item>
                        <el-menu-item index="/home/userList">
                            待审核用户
                        </el-menu-item>
                        <el-menu-item index="/home/userTransaction">
                            用户交易记录
                        </el-menu-item>
                        <el-menu-item index="/home/carrier">
                            载体库
                        </el-menu-item>
                        <el-menu-item index="/home/seqCompany">
                            测序公司管理
                        </el-menu-item>
                        <el-menu-item index="/home/welcomeSet">
                            欢迎页设置
                        </el-menu-item>
                        <el-menu-item index="/home/orderTip">
                            填写提示管理
                        </el-menu-item>
                        <el-menu-item index="/home/systemSet">
                            系统设置
                        </el-menu-item>
                        <el-menu-item index="/home/operateLog">
                            操作日志
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="2">
                        <template slot="title"><i class="el-icon-menu"></i>订单管理</template>
                        <el-menu-item index="/home/orderInfo" v-if="isHasOrderInfo">
                            订单列表
                        </el-menu-item>
                        <el-menu-item index="/home/overallOrder" v-if="isHasOverallOrder">
                            统筹订单
                        </el-menu-item>
                        <el-menu-item index="/home/hasOveralledOrder" v-if="isHasOverallOrder">
                            已统筹订单
                        </el-menu-item>
                        <el-menu-item index="/home/notSubmitOrderInfo" v-if="isHasNotSubmitOrderInfo">
                            未提交订单
                        </el-menu-item>
                        <el-menu-item index="/home/myOrderInfo" v-if="isHasMyOrderInfo">
                            我的订单
                        </el-menu-item>
                        <el-menu-item index="/home/groupOrderInfo" v-if="isHasGroupOrderInfo">
                            群组订单
                        </el-menu-item>
                        <el-menu-item index="/home/transaction" v-if="isHasTransaction">
                            我的账户
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div>
                <el-dropdown>
                    <!-- <i class="el-icon-user" style="margin-right: 15px;background-color:#eee;"></i> -->
                    <i class="el-icon-user" style="margin-right: 15px;color:white;"></i>
                    <el-dropdown-menu slot="dropdown" split-button="true">
                    <el-dropdown-item @click.native="updatePassword">修改密码</el-dropdown-item>
                    <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <span>当前登录人：{{user.userRealName}}</span>
            </div>
        </el-header>

        <el-container style="height: 0; border: 1px solid #eee">
            <el-main>
                <router-view></router-view>
                <el-dialog title="请设置新密码" :visible.sync="dialogFormVisible"  append-to-body>
                    <el-form :model="updateUser" :rules="rules" ref="updateUserForm" size="mini" label-width="100px">
                        <el-form-item label="密码" prop="password">
                            <el-input placeholder="请输入密码" v-model="updateUser.password" show-password></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="doUpdatePassword('updateUserForm')">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import globeCommon from '../assets/js/GlobeCommon.js'
    export default {
        name:'Home',
        data() {
            // var validatePassword = (rule, value, callback) => {
            //     if(value) {
            //         let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/
            //         if(!reg.test(value)) {
            //             callback(new Error("密码必须包含字母和数字，长度为8-20位"));
            //         }
            //     }
            //     callback();
            // };
            return {
                updateUser: {},
                rules: {
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ]
                },
                user: {},
                isCollapse: true,
                dialogFormVisible: false,
                isDisabled: false,
                isShowMyOrderInfo: true,
                isHasOrderInfo: false,
                isHasOverallOrder: false,
                isHasNotSubmitOrderInfo: false,
                isHasMyOrderInfo: false,
                isHasGroupOrderInfo: false,
                isHasTransaction: false,
            }
        },
        methods: {
            updatePassword() {
                var formName = 'updateUserForm';
                this.dialogFormVisible = true;
                if(this.$refs[formName]) {
                    this.$refs[formName].resetFields();
                }
            },
            doUpdatePassword(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post("/login/updatePassword",this.updateUser).then(
                            res=>{
                                if(res.data.status === "success"){
                                    this.$message.success("密码修改成功！");
                                    this.dialogFormVisible = false;
                                } else {
                                    this.$message.error(res.data.message);
                                }
                            },
                            error=>{
                                this.$message.error(error.message);
                            }
                        )
                    } else {
                        return false;
                    }
                });
                
            },
            logout() {
                this.$axios.post("/login/logout").then(
                    res=>{
                        if(res.data.status === "success"){
                            window.localStorage.removeItem("user");
                            window.localStorage.removeItem("userId");
                            this.$router.push("/login");
                            globeCommon.userId = "";
                        } else {
                            this.errorMsg = res.data.message;
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                        this.$router.push("/login");
                    }
                )
            }

        },
        created() {
            this.user = JSON.parse(window.localStorage.getItem("user"));
            if(this.user.roleCode === 'SUPER') {
                // this.$router.push("/home/orderInfo");
                this.isDisabled = true;
                this.isHasOrderInfo = true;
                this.isHasOverallOrder = true;
            } else if(this.user.roleCode === 'ADMIN') {
                // this.$router.push("/home/orderInfo");
                this.isHasOrderInfo = true;
                this.isHasOverallOrder = true;
            } else if (this.user.roleCode === 'AGENT') {
                // this.$router.push("/home/groupOrderInfo");
                this.isHasGroupOrderInfo = true;
                this.isHasTransaction = true;
            } else if(this.user.roleCode === 'RESPONSIBLE') {
                // this.$router.push("/home/myOrderInfo");
                this.isHasNotSubmitOrderInfo = true;
                this.isHasMyOrderInfo = true;
                this.isHasGroupOrderInfo = true;
                this.isHasTransaction = true;
            } else {
                // this.$router.push("/home/myOrderInfo");
                this.isHasNotSubmitOrderInfo = true;
                this.isHasMyOrderInfo = true;
                this.isHasTransaction = true;
            }
        },
        mounted() {
            
        }
        
    }


</script>

<style lang="less" scoped>
    
    .home-container {
        position:absolute;
        height: 98%;
        width: 99%;
    }
    .el-header {
        background-color: #545c64;
        color: rgb(242, 245, 247);
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        padding-left: 0;
    }

    .el-header div {
        display: flex;
        align-items: center;
    }
    
    .el-aside {
        color: #333;
    }
    .el-main {
        width: 99%;
    }

    
</style>
